<template>
  <v-card class="rounded-lg delete-dialog">
    <v-card-title class="d-flex justify-space-between align-center pa-6 pb-4">
      <div class="d-flex align-center">
        <v-icon
          v-if="blocked"
          color="orange"
          class="mr-2"
        >
          mdi-information-outline
        </v-icon>
        <v-icon
          v-else
          color="red"
          class="mr-2"
        >
          mdi-alert-outline
        </v-icon>
        <span class="text-h6 font-weight-bold">Hapus Channel Provider</span>
      </div>
      <v-btn icon @click="onClose" :disabled="loading">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text class="pa-6 pt-0">
      <div
        v-if="blocked"
        class="rounded-lg pa-4 blocked-alert"
      >
        <div class="font-weight-bold orange--text text--darken-3 mb-2">
          Tidak dapat menghapus provider ini
        </div>
        <div class="text-body-2">
          <strong>{{ providerName }}</strong> masih digunakan oleh
          <strong>{{ merchantCount }} merchant</strong>. Lepaskan mapping
          merchant terlebih dahulu sebelum menghapus channel provider.
        </div>
      </div>

      <div
        v-else
        class="rounded-lg pa-4 confirm-alert"
      >
        <div class="text-body-2 red--text text--darken-2">
          Apakah Anda yakin ingin menghapus channel provider
          <strong>{{ providerName }}</strong>?
          Tindakan ini tidak dapat dibatalkan.
        </div>
      </div>
    </v-card-text>

    <v-card-actions class="pa-6 pt-0">
      <v-spacer />
      <template v-if="blocked">
        <v-btn
          outlined
          color="primary"
          class="rounded-lg px-6"
          @click="onClose"
          :disabled="loading"
        >
          Tutup
        </v-btn>
      </template>
      <template v-else>
        <v-btn
          outlined
          color="primary"
          class="rounded-lg px-6 mr-2"
          @click="onClose"
          :disabled="loading"
        >
          Batal
        </v-btn>
        <v-btn
          color="red"
          class="rounded-lg elevation-0 px-6 white--text"
          @click="onConfirm"
          :loading="loading"
          :disabled="loading"
        >
          Hapus
        </v-btn>
      </template>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: 'ChannelProviderDeleteDialog',
  props: {
    providerName: { type: String, default: '' },
    merchantCount: { type: Number, default: 0 },
    loading: { type: Boolean, default: false },
  },
  computed: {
    blocked() {
      return this.merchantCount > 0;
    },
  },
  methods: {
    onClose() {
      this.$emit('cancel');
    },
    onConfirm() {
      this.$emit('confirm');
    },
  },
};
</script>

<style scoped>
.confirm-alert {
  background-color: #fff5f5;
  border: 1px solid #ffd5d5;
}
.blocked-alert {
  background-color: #fff8e6;
  border: 1px solid #ffe1a8;
}
</style>
